import type { State, Vec3 } from "../shared/types.js";
// The simulation keeps its quantized orientation. Presentation uses the newest
// mouse position on every rendered frame, even when no physics tick was due.
export function presentPlayer(
  state: State,
  previous: Vec3 | undefined,
  accumulator: number,
  look: { yaw: number; pitch: number },
): State {
  const from = previous ?? state.p;
  const interpolate = Math.hypot(...state.p.map((n, i) => n - from[i])) < 128;
  const alpha = Math.max(0, Math.min(1, accumulator / 0.01));
  return {
    ...state,
    yaw: look.yaw,
    pitch: look.pitch,
    p: state.p.map((n, i) =>
      interpolate ? from[i] + (n - from[i]) * alpha : n,
    ) as Vec3,
  };
}
